export const environment = {
  production: false,
  // add other dev settings if needed
};